// bao migrate skip 
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import TabPage from "./../../factories/tab-page";
// bao migrate - module not found: import Synoset from "modules/synoset-module";
import ChildTabViewModel from "./../../factories/child-tab-view-model";
import AppTabController from "../../services/app-tab-controller";
function ConfigurationItemTicketViewModel(tabPage, parent) {
    var self = this;
    ChildTabViewModel.call(self, tabPage);
    self.Bao = Bao;
    self.SelectedTicketStatusId = ko.observable("5adee74f-6358-478d-ac52-053b589f7acb");
    self.SelectedTicketStatusId.subscribe(function (value) {
        self.RefreshGridTicket();
    });
    self.TicketButtons = ko.observableArray();
    self.TicketButtons.subscribe(function () {
        self.EnableTicketButtons();
    });
    self.ConfigurationItem = parent;
    self.RefreshInProgress = ko.observable(false);
    self.PageSize = ko.observable(10);
    self.PageIndexTicket = ko.observable(0);
    self.PageIndexTicket.subscribe(function () {
        self.RefreshGridTicket();
    });
    self.TotalRowsTicket = ko.observable(0);
    self.SortingTicket = ko.observableArray();
    self.SortingTicket.subscribe(function () {
        self.RefreshGridTicket();
    });
    self.TicketStatuses = ko.observableArray([]);
    self.TicketCollection = ko.observableArray([]);
    self.SelectTicketRow = function (item) {
        self.SelectedTicketRow(item);
        return true;
    };
    self.SelectedTicketRow = ko.observable({});
    self.SelectedTicketRow.subscribe(function () {
        self.EnableTicketButtons();
    });
    self.toolbarClick = function (action) {
        switch (action.ActionKey()) {
            case "ConfigurationItemTicketAdd":
                self.AddTicket();
                break;
            case "ConfigurationItemTicketEdit":
                self.EditTicket(self.SelectedTicketRow());
                break;
            case "ConfigurationItemTicketRefresh":
                self.RefreshGridTicket();
                break;
        }
    };
    self.AddTicket = function () {
        var newTab = new TabPage();
        newTab.Url("Ticket");
        newTab.UrlData({
            AffectedItemId: parent.ConfigurationItemId()
        });
        AppTabController.AddTab(newTab);
    };
    self.EditTicket = function (item) {
        if (item != null) {
            var newTab = new TabPage();
            newTab.Url("Ticket");
            newTab.UrlData({
                id: item.OpenData
            });
            newTab.ObjectId(item.OpenData);
            AppTabController.AddTab(newTab);
        }
    };
    self.RefreshGridTicket = function () {
        tabPage.IsLoading(true);
        return Bao.post("ConfigurationItemTab/GetConfigurationItemTicketCollection", JSON.stringify({
            sessionTabId: self.ConfigurationItem.TabPage.SessionTabId,
            configurationItemId: self.ConfigurationItem.ConfigurationItemId(),
            ticketStatusId: self.SelectedTicketStatusId(),
            configurationItemTypeCategoryKey: self.ConfigurationItem.ConfigurationItemTypeCategoryKey(),
            pageIndex: self.PageIndexTicket(),
            pageSize: self.PageSize(),
            sorting: self.SortingTicket()
        }), function (searchResult) {
            tabPage.IsLoading(false);
            self.SelectedTicketRow(null);
            self.TotalRowsTicket(0);
            self.TicketCollection([]);
            if (searchResult != null && searchResult.Models != null) {
                self.TicketCollection(searchResult.Models);
                self.TotalRowsTicket(searchResult.TotalRows);
            }
        });
    };
    self.EnableTicketButtons = function () {
        $.each(self.TicketButtons(), function (index, item) {
            if (item.ActionKey() == "ConfigurationItemTicketEdit") {
                if (self.SelectedTicketRow() != null && (self.SelectedTicketRow().IsInherited == null || self.SelectedTicketRow().IsInherited == false)) {
                    item.Enabled(true);
                }
                else {
                    item.Enabled(false);
                }
            }
        });
    };
    self.Refresh = function () {
        var def = $.Deferred();
        self.RefreshGridTicket().then(function () {
            def.resolve();
        });
        return def.promise();
    };
    self.CompleteCheck = function () {
        return true;
    };
    self.init = function () {
        return Bao.post("ConfigurationItemTab/ConfigurationItemTicketTabModel", function (result) {
            ko.map.fromJS(result, self, tabPage.DirtyFlag);
        });
    };
    self.loaded = function () {
        return self.Refresh();
    };
}
;
Bao.inherit(ConfigurationItemTicketViewModel, ChildTabViewModel);
export default ConfigurationItemTicketViewModel;